<template>
  <div class="ProjectInformation">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span class="font-sz24">会话节点维护</span>
      </div>
    </el-card>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="zwwp03" label="名称" align="center">
      </el-table-column>
      <el-table-column prop="zwwp06" label="更新时间" align="center">
      </el-table-column>
      <el-table-column prop="zwwp08" label="启用禁用" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.zwwp08"
            :active-value="0"
            :inactive-value="1"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="
              (data) => {
                WorkPlaneIsOpen(data, scope.row);
              }
            "
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="zwwp08" label="重命名" align="center">
        <template slot-scope="scope">
          <el-button @click="reName(scope.row)" type="primary" size="small"
            >重命名</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  // 树的操作
  GetWorkPlane,
  WorkPlaneIsOpen,
  RenameWorkPlane,
} from "@/setAxios.js";
import template from "../barCode/template.vue";
export default {
  components: { template },
  name: "ProjectInformation",
  data() {
    return {
      tableData: [],
    };
  },
  created() {
    this.GetWorkPlane();
  },
  methods: {
    async WorkPlaneIsOpen(data, data2) {
      let res = await WorkPlaneIsOpen({ id: data2.zwwp01 });
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "操作成功",
        });
      }
    },
    reName(data) {
      this.$prompt("重命名", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async ({ value }) => {
        let params = {
          id: data.zwwp01,
          name: value,
        };
        let res = await RenameWorkPlane(params);
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.GetWorkPlane();
        }
      });
    },
    async GetWorkPlane() {
      let params = {
        xid: localStorage.xid,
        type: 0,
      };
      let res = await GetWorkPlane({ params });
      this.tableData = res.Data;
    },
  },
};
</script>

<style lang="less" scoped>
div#sessionRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#sessionRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#sessionRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#sessionRemenu ul li:hover {
  background: #eee;
  color: #000000;
}
#sessionTrss {
  height: 500px;
}
.zTreeDiv {
  overflow: auto;
}
.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}
.userManagement .search-input {
  width: 300px;
}
// 新增
.font-sz24 {
  font-size: 24px;
}
.elAside {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
}
.mar-left10 {
  margin-left: 10px;
}
.w-mar-bot20 {
  width: 100%;
  margin-bottom: 20px;
}
.text-p {
  color: red;
  text-align: center;
  margin-bottom: 10px;
}
.pad-bot0 {
  padding-bottom: 0;
}
.width100 {
  width: 100%;
}
.cor00c {
  color: #00c4ff;
}
</style>
